function getSourceLabel(source) {
  try {
    const hostname = new URL(source).hostname.replace(/^m\./, "").replace(/^www\./, "");
    if (hostname === "media-amazon.com") return "Amazon media";
    return hostname;
  } catch {
    return "Source link";
  }
}

function dedupeShowCredits(credits) {
  const byKey = new Map();

  credits.forEach((credit) => {
    const key = [
      credit.title ?? "",
      credit.creator ?? "",
      credit.source ?? "",
      credit.license ?? "",
      credit.licenseUrl ?? "",
      credit.notes ?? "",
    ].join("|");

    if (!byKey.has(key)) {
      byKey.set(key, {
        ...credit,
        usageList: credit.assetUsage ? [credit.assetUsage] : [],
      });
      return;
    }

    const existing = byKey.get(key);
    if (credit.assetUsage && !existing.usageList.includes(credit.assetUsage)) {
      existing.usageList.push(credit.assetUsage);
    }
  });

  return [...byKey.values()].map((item) => ({
    ...item,
    assetUsage: item.usageList.join(" + "),
  }));
}

const DATA_SOURCES = [
  {
    label: "TVMaze API",
    href: "https://www.tvmaze.com/api",
    note: "Series metadata, episode lists, and base cast references.",
  },
  {
    label: "IMDb",
    href: "https://www.imdb.com/",
    note: "Actor profile links, ratings, and popularity references.",
  },
  {
    label: "Manual editorial curation",
    href: "/credits",
    note: "Filming offsets, cameo mapping, and quality-control adjustments.",
  },
];

export function CreditsPage({ credits }) {
  const creditsByShow = new Map();
  credits.forEach((credit) => {
    if (!creditsByShow.has(credit.showId)) {
      creditsByShow.set(credit.showId, {
        showTitle: credit.showTitle,
        credits: [],
      });
    }
    creditsByShow.get(credit.showId).credits.push(credit);
  });

  const element = document.createElement("section");
  element.className = "page-shell credits-page";

  element.innerHTML = `
    <h1 class="credits-page-title">Image credits</h1>
    <p class="credits-page-desc">
      Show page heroes and home page card images are credited here. Reference-only pages are listed separately and not used in the UI.
    </p>

    <section class="data-sources-section">
      <div class="data-sources-title">Data sources</div>
      <ul class="data-sources-list">
        ${DATA_SOURCES.map(
          (source) => `
            <li class="data-source-row">
              <a class="credit-link" href="${source.href}" target="_blank" rel="noreferrer">${source.label}</a>
              <span class="data-source-note">${source.note}</span>
            </li>
          `,
        ).join("")}
      </ul>
    </section>

    ${[...creditsByShow.values()]
      .map(({ showTitle, credits: showCredits }) => {
        const uniqueCredits = dedupeShowCredits(showCredits);
        return `
        <article class="credit-card">
          <div class="credit-card-title">${showTitle}</div>
          ${uniqueCredits
            .map(
              (credit) => `
              <div class="credit-asset">
                <div class="credit-meta">
                  <div>
                    <span class="credit-meta-label">Used for</span>
                    <span class="credit-meta-value">${credit.assetUsage ?? "Show page hero"}</span>
                  </div>
                  <div>
                    <span class="credit-meta-label">Asset</span>
                    <span class="credit-meta-value">${credit.title}</span>
                  </div>
                  <div>
                    <span class="credit-meta-label">Creator</span>
                    <span class="credit-meta-value">${credit.creator}</span>
                  </div>
                  <div>
                    <span class="credit-meta-label">Source</span>
                    <span class="credit-meta-value">
                      <a class="credit-link" href="${credit.source}" target="_blank" rel="noreferrer">${getSourceLabel(credit.source)}</a>
                    </span>
                  </div>
                  <div>
                    <span class="credit-meta-label">License</span>
                    <span class="credit-meta-value">
                      <a class="credit-link" href="${credit.licenseUrl}" target="_blank" rel="noreferrer">${credit.license}</a>
                    </span>
                  </div>
                </div>
                ${credit.notes ? `<p class="credit-note">${credit.notes}</p>` : ""}
              </div>
            `,
            )
            .join("")}
        </article>
      `;
      })
      .join("")}

    <div class="reference-section">
      <div class="reference-section-title">Reference-only alternatives</div>
      <p class="reference-section-desc">Reviewed for framing only — not used in the app.</p>
      <ul class="reference-links-list">
        <li><a href="https://www.netflix.com/title/70153373" target="_blank" rel="noreferrer">Netflix Seinfeld page</a></li>
        <li><a href="https://www.peacocktv.com/stream-tv/the-office" target="_blank" rel="noreferrer">Peacock The Office page</a></li>
      </ul>
    </div>
  `;

  return {
    title: "Credits · HowOldHere",
    element,
  };
}
